import { _ as t } from "../internals/export.js";
t({
  target: "Reflect",
  stat: !0
}, {
  has: function has(t, r) {
    return r in t;
  }
});